import React, { Component } from 'react';

import { Polyline } from 'google-maps-react';


class UndergroundObject extends Component {

    componentDidMount() {
        this.loadUnderGroundObjectsList();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.undergroundObjectsList.length !== nextProps.undergroundObjectsList.length
            || this.props.showUndergrounObjectsLayer !== nextProps.showUndergrounObjectsLayer) {
            return true;
        }
        else {
            return false;
        }
    }

    componentDidUpdate(){
        this.loadUnderGroundObjectsList();
    }


    loadUnderGroundObjectsList = () => {
        var resultList = [];
        if (this.props.showUndergrounObjectsLayer
            && this.props.undergroundObjectsList
            && this.props.undergroundObjectsList.length > 0) {

            this.props.undergroundObjectsList.forEach((object, index) => {
                let underGroundObjectElement =
                    <Polyline
                        key={'UndergroundObject' + index}
                        path={object.path}
                        name={'Underground object on: OHL: ' + String(object.ohl) + ' Span: ' + String(object.span)}
                        clicable
                        onClick={this.props.onUndergroundObjectClick}
                        strokeOpacity={1}
                        strokeColor='#8a6501'
                        strokeWeight={this.props.ohlThickess + 6}
                        ohl={object.ohl}
                        span={object.span}
                        objects={object.objects}
                    />


                resultList.push(underGroundObjectElement);
            });
        }
        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    render() {
        return null;
    }
}


export default UndergroundObject;